import React, { useEffect, useState } from 'react'
import * as Api from "../../config/Apis"
import endPoints from "../../config/endpoints";
import moment from 'moment/moment';
import { Badge, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheck, faChevronLeft, faExclamation, faWarning } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../components/pagination';
import _ from "underscore"
import MapView from './Map';

const tabs = [
  { label: "Owner", value: "createdByUser", count: "totalCreated" },
  { label: "Member", value: "memberOf", count: "totalMemberOf" },
]
export default function UserDetail() {
  const param = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [activeuser, setActiveUser] = useState({});
  const [activeWire, setActiveWire] = useState({});
  const [activeWireUser, setActiveWireUser] = useState({});
  const [activeTab, setActivetab] = useState(tabs[0].value);
  const [modal, setModal] = useState({
    show: false,
    type: ""
  })
  const handleTab = (item) => {
    setActivetab(item.value)
  }
  const handleClose = () => {
    setModal({ show: false, type: "" })
    setActiveWire({})
    setActiveWireUser({})
  }

  const getUserDetail = (id) => {
    Api.GetApi(endPoints.USERDETAIL + `/${id}`).then(res => {
      setLoading(false)
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        if (res.data.data) {
          setActiveUser(res.data.data);
        }
      }
    })
  }
  const getWireDetail = (id) => {
    Api.GetApi(endPoints.WIRE_DETAILS + `/${id}`).then(res => {
      setLoading(false)
      if (res.error === true) {
        Api.Alert(res.response.data.error, "error")
      } else {
        if (res.data.data) {
          setActiveWire(res.data.data);
          setModal({ show: true, type: "wire" })
        }
      }
    })
  }

  const handleWire = (item) => {
    getWireDetail(item.wire_id)
  }
  const handleWireClick = (item) => {
    if (activeWireUser._id === item._id) {
      setActiveWireUser({})
    } else {
      setActiveWireUser(item)
    }
  }

  useEffect(() => {
    if (param.id) {
      getUserDetail(param.id)
    }
  }, [param])

  return (
    <main>
      <div className='container-fluid'>
        <div className='card'>
          <div className='card-body'>
            <div className="d-flex gap-1 align-items-center justify-content-between">
              <h2><button onClick={() => navigate(-1)}><FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: "80%" }} /> {activeuser?.user?.first_name || ""}</button></h2>
            </div>
            <div className='user_detail'>
              <div className='row g-5'>
                <div className='col-md-6'>
                  <div className='custom_tabs'>
                    {tabs.map((item, index) => (
                      <button key={index} className={`tab_btn ${item.value === activeTab ? "active" : ""}`} onClick={() => handleTab(item)}>{item.label} ({(activeuser?.counts && activeuser?.counts[item.count]) || 0})</button>
                    ))}
                  </div>
                  <div className='custom_tab_panel'>
                    <div className='user_table'>
                      <table className='table'>
                        <thead>
                          <tr>
                            <th width={80}>#</th>
                            <th>Name</th>
                            <th>Role</th>
                          </tr>
                        </thead>
                        {!_.isEmpty(activeuser) && activeuser[activeTab].length ?
                          <tbody>
                            {activeuser[activeTab].map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td style={{ cursor: "pointer" }} onClick={() => handleWire(item)}>{index + 1}</td>
                                  <td style={{ cursor: "pointer" }} onClick={() => handleWire(item)}>{item.name || ""}</td>
                                  <td style={{ cursor: "pointer" }} onClick={() => handleWire(item)} className='text-capitalize'>{item.role || ""}</td>
                                </tr>
                              )
                            }
                            )}
                          </tbody>
                          :
                          <tbody>
                            <tr>
                              <td colSpan={3} className='text-center'>No data found.</td>
                            </tr>
                          </tbody>
                        }
                      </table>
                    </div>
                  </div>
                </div>

                <div className='col-md-6'>
                  <h3>Last location</h3>
                  <h5>{activeuser?.user?.currentLocation?.locationName || "-"}</h5>
                  {!_.isEmpty(activeuser) && activeuser?.user?.currentLocation && activeuser?.user?.currentLocation?.lat && activeuser?.user?.currentLocation?.lng ?
                    <div className='user_map'>
                      <MapView lat={activeuser?.user?.currentLocation?.lat} lng={activeuser?.user?.currentLocation?.lng} />
                    </div>
                    :
                    null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={modal.show} onHide={handleClose} size="xl" className="custom_modal">
        <Modal.Header closeButton>
          <Modal.Title className="h3 d-flex justify-content-between align-items-center w-100">
            <span>{activeWire.name} ({activeWire?.members_count})</span>
            <small>Last update: {activeWire.updatedAt ? moment(activeWire.updatedAt).format("lll") : "-"}</small>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='custom_tab_panel'>
            <div className='user_table'>
              <table className='table'>
                <thead>
                  <tr>
                    <th width={80}>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th>Last update</th>
                    <th>Role</th>
                  </tr>
                </thead>
                {activeWire && activeWire.members && activeWire.members.length ?
                  <tbody>
                    {activeWire.members.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr className={activeWireUser && activeWireUser._id === item._id ? "active" : ""}>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)}>{index + 1}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)}>{item?.user_details?.first_name || ""} {item?.user_details?.last_name || ""} {item?.is_admin ?
                              <Badge pill style={{ fontWeight: 300, marginRight: "5px" }} bg={"primary"}>Admin</Badge>
                              : null
                            }
                            </td>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)}>{item?.user_details?.email || ""}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)}>{item.createdAt ? moment(item.createdAt).format("lll") : "-"}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)}>{item.updatedAt ? moment(item.updatedAt).format("lll") : "-"}</td>
                            <td style={{ cursor: "pointer" }} onClick={() => handleWireClick(item)} className='text-capitalize'>{item.role || "-"}</td>
                          </tr>
                          {activeWireUser && activeWireUser._id === item._id ?
                            <tr>
                              <td colSpan={6}>
                                <div className='p-1'>
                                  <h5 className='mb-2'>Last location</h5>
                                  <p>{item?.user_details?.currentLocation?.locationName || "-"}</p>
                                  {item?.user_details?.currentLocation && item?.user_details?.currentLocation?.lat && item?.user_details?.currentLocation?.lng ?
                                    <div className='user_map'>
                                      <MapView height='200px' lat={item?.user_details?.currentLocation?.lat} lng={item?.user_details?.currentLocation?.lng} />
                                    </div>
                                    :
                                    null
                                  }
                                </div>
                              </td>
                            </tr>
                            : null
                          }
                        </React.Fragment>
                      )
                    }
                    )}
                  </tbody>
                  :
                  <tbody>
                    <tr>
                      <td colSpan={3} className='text-center'>No data found.</td>
                    </tr>
                  </tbody>
                }
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </main>
  )
}
